export default class EventEmitter {
	_events = {}

	hasListeners = () => {
		return Object.values(this._events).some((item) => item.length)
	}

	on(event, listener) {
		this._events[event] = this._events[event] || []
		this._events[event].push(listener)

		return () => this.off(event, listener)
	}

	off(event, listener) {
		if (!this._events[event]) {
			return
		}

		const index = this._events[event].indexOf(listener)

		if (index < 0) {
			return
		}

		this._events[event].splice(index, 1)
	}

	emit = ({ event, ...rest }) => {
		const listeners = this._events[event]

		if (!listeners) {
			return
		}

		listeners.forEach((listener) => listener(rest))
	}
}
